interface ErrorProps {
  data: {
    message: string;
  };
}

export function isError(error: unknown): error is ErrorProps {
  return typeof error === "object" && error != null && "data" in error;
}
